__webpack_require__.p = "/dice/";